// extracted by mini-css-extract-plugin
module.exports = {"root":"CreditCard_root__2JArD","number":"CreditCard_number__27x0q","buttons":"CreditCard_buttons__2GD-j"};